import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87f5e8b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5 relative data-table" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex flex-col justify-center items-center absolute top-36"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-v_red w-28" }
const _hoisted_5 = { class: "w-32" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { VDataTableServer } from "vuetify/labs/VDataTable"
import {
	ref,
	onMounted,
	PropType,
	computed,
} from "vue"
import { useStore } from "@/store"
import { H2 } from "@/components/atoms"
import { hasPermission } from "@/utils/permissions"
import ItemsTable from "./ItemsTable.vue"
import { IData, IHeaders, IItems, IItemsByCommission } from "@/utils/interfaces"
import { Notification, Permission, Status } from "@/utils/enum"
import { getItemByCommission } from "@/repositories/commissions"
import { getAdjustments, insertAdjustments } from "@/repositories/adjustments"
import CreateAdjustment from "./CreateAdjustmentModal.vue"
import FitDisplayModal from "./FitDisplayModal.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
	data: { type: Array as PropType<IData[]>, required: true },
	perPage: { type: Number, required: true },
	totalPages: { type: Number, required: true },
	page: { type: Number, required: true },
},
  emits: [
	"getCommissions",
	"emitError",
	"perPage",
	"commissions",
	"enableLoading",
	"successInAdjustingTheCommission",
	"removeCommission",
	"selectAllCommissions",
	"setPerPage",
	"sessionExperid",
	"clearAllCommissions",
	"getPerPage",
	"setPagination",
],
  setup(__props, { emit }) {

const props = __props;



let showCreateFitModal = ref(false)
let idCommission = ref(0)
let base = ref("")
let adjustment = ref<any[]>([])
let totalPortion = ref<number[]>([])
let situation = ref("")
let items = ref<IItems[]>([])
let headers = ref<IHeaders[]>([])
let fitColor = ref<boolean[]>([])
let validationError = ref(false)
let showFitDisplayModal = ref(false)
let showItemsTable = ref(false)
let itemsPerPage = ref(props.perPage)
let pages = ref(props.page)
let negativeGroosCommission = ref<boolean[]>([])
let negativeNetCommission = ref<boolean[]>([])
let negativeTotalNetCommission = ref<boolean[]>([])
let selected = ref<number[]>([])
let checked = ref(false)
let pageText = ref("")

const store = useStore()

const header = [
	{
		title: "Consultas",
		key: "data-table-expand",
		sortable: false,
		tooltip: "Permite ações como consultar ou ajustar ",
	},
	{
		title: "Cliente",
		key: "client",
		sortable: false,
		tooltip: "Cliente final referente a nota fiscal",
	},
	{
		title: "Nota",
		key: "note",
		sortable: false,
		tooltip: "Número da nota fiscal",
	},
	{
		title: "Parcela",
		key: "portion",
		sortable: false,
		tooltip: "Número da parcela/Número total de parcelas",
	},
	{
		title: "Validade",
		key: "validate",
		sortable: false,
		tooltip: "Data de vencimento da nota fiscal",
	},
	{
		title: "Comissão bruta",
		key: "groosCommission",
		sortable: false,
		tooltip: "Valor total de comissão",
	},
	{
		title: "Desconto",
		key: "discount",
		sortable: false,
		tooltip: "Descontos da comissão bruta",
	},
	{
		title: "Ajuste",
		key: "adjustment",
		sortable: false,
		tooltip: "Ajustes referente a comissão",
	},
	{
		title: "Comissão liquida",
		key: "netCommission",
		sortable: false,
		tooltip: "Valor total de comissão com descontos",
	},
	{
		title: "C. Liquida Total",
		key: "totalNetCommission",
		sortable: false,
		tooltip: "Comissão liquida total, independente da parcela",
	},
	{
		title: "Total NF-e",
		key: "totalSales",
		sortable: false,
		tooltip: "Valor totoal da NF-e",
	},
	{
		title: "Status",
		key: "status",
		sortable: false,
		tooltip: "Indica o status da nota",
	},
]



const getPerPage = (value: any) => {
	emit("getPerPage", value, "itemsPerPage")
}

const onChangePage = (value: any) => {
	emit("setPagination", value, "pagination")
}

const setItemsPerPage = computed(() => {
	let items = [
		{ title: "10", value: 10 },
		{ title: "25", value: 25 },
		{ title: "50", value: 50 },
		{ title: "75", value: 75 },
		{ title: "100", value: 100 },
	]

	if (
		hasPermission([Permission.RESALE]) &&
		situation.value == Status.AVAILABLE
	) {
		items.push({
			title: "Todas",
			value: -1,
		})
	}

	return items
})

const getCommissionAdjust = async (Index: number) => {
	const data = props.data.filter((_, index) => index == Index)

	idCommission.value = data[0].id
	base.value = data[0].base
	showCreateFitModal.value = true
}

const createFit = async (adjust: any) => {
	if (adjust.reason != "") {
		emit("enableLoading", true)

		const res: any = await insertAdjustments(
			base.value,
			idCommission.value,
			adjust.reason,
			adjust.value
		)

		if (res?.status == 201) {
			emit("successInAdjustingTheCommission")
		} else if (res?.status == 422) {
			showCreateFitModal.value = false
			emit("enableLoading", false)
			emit(
				"emitError",
				true,
				Notification.TITLE_ERROR_ADJUSTED_COMMISSION,
				Notification.SUBTITLE_ERROR_ADJUSTED_COMMISSION
			)
		} else if (res?.response.status >= 500) {
			showCreateFitModal.value = false
			emit("enableLoading", false)
			emit(
				"emitError",
				true,
				Notification.TITLE_ERROR,
				Notification.SUBTITLE_ERROR
			)
		}
	} else {
		validationError.value = true
	}
}

const takeAdjustments = async (Index: number) => {
	const data = props.data.filter((_, index) => index == Index)

	emit("enableLoading", true)

	const id = data[0].id
	const base = data[0].base

	const res: any = await getAdjustments(base, id)

	if (res.status == 200 && res.message.data != null) {
		adjustment.value = res.message.data
		showFitDisplayModal.value = true
	} else if (res.message.data == null) {
		emit(
			"emitError",
			true,
			Notification.TITLE_COMMISSION_WITHOUT_ADJUSTMENT,
			Notification.SUBTITLE_COMMISSION_WITHOUT_ADJUSTMENT
		)
		showFitDisplayModal.value = false
	}

	emit("enableLoading", false)
}

let takeItemsByCommission = async (Index: number) => {
	console.log("Entrou aqui ")
	const data = props.data.filter((_, index) => index == Index)

	emit("enableLoading", true)

	const id = data[0].id
	const base = data[0].base

	const res: any = await getItemByCommission(id, base)
	console.log("Entrou aqui ")

	if (res.status == 200) {
		parseCommissionData(res.message.data)
		showItemsTable.value = true
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
		showItemsTable.value = false
	}

	emit("enableLoading", false)
}

const parseCommissionData = (data: IItemsByCommission[]) => {
	console.log("Entrou aqui ")
	items.value = data.map((d: IItemsByCommission): IItems => {
		return {
			item: d.ItemCode,
			description: d.Dscription,
			amount: d.Quantity,
			rev: d.PrecoRev,
			final: d.PrecoFinal,
			commission: d.ComissaoBruto,
			icms: d["ICMS#"],
			ipi: d["IPI#"],
			pis: d["PIS#"],
			confins: d["COF#"],
			issIrCsll: d.ISS,
			freight: d.Frete,
			netCommission: d.ComissaoLiquida,
			status: d.status,
			rebate: d.Rebate,
		}
	})
}

const filterCommissions = (id: number[]) => {
	const commissions = props.data.filter((c) => id.includes(c.id))

	emit("getCommissions", commissions)
}

const select80FirstAvailableCommissions = () => {
	if (!checked.value) {
		checked.value = true
		selected.value = []
		// Nova regra: Deve selecionar automaticamente no maximo 80 linhas de comissão.
		for (let i = 0; i < props.data.length; i++) {
			if (selected.value.length < 80) {
				selected.value.push(props.data[i].id)
			}
		}
		// selected.value = props.data.map((e) => e.id) //Essa parte fazia com que todas as comissões fossem selecionadas
		getRowStyle(selected.value)
	} else {
		checked.value = false
		selected.value = []

		getRowStyle(selected.value)
	}
}

//muda a cor da linha da tabela que foi selecionada no checkbox
const getRowStyle = (id: number[]) => {
	let tr = document.getElementsByTagName("tr")
	let checkbox = document.getElementsByTagName("input")

	for (let i = 0; i <= tr.length + 1; i++) {
		if (id.includes(Number(tr[i]?.id))) {
			const td = tr[i]?.getElementsByTagName("td")

			if (checkbox[i]) {
				for (let i = 0; i <= td.length; i++) {
					td[i]?.setAttribute("style", "background: #4AD98933")
				}
			}
		} else {
			const td = tr[i]?.getElementsByTagName("td")

			if (td) {
				for (let i = 0; i <= td.length; i++) {
					td[i]?.setAttribute("style", "background: #fff")
				}
			}
		}
	}

	filterCommissions(id)
}

const handlingTheTable = () => {
	if (props.data.length == 0) {
		//oculta o texto 'No data available' da tabela
		const td = document.getElementsByTagName("td")
		td[0].style.display = "none"

		//oculta o footer da tabela
		const footer = document.getElementsByClassName("v-data-table-footer")
		footer[0].setAttribute("style", "display: none")
	} else {
		//modifica o texto da paginação da tabela
		pageText.value = `${pages.value}-${itemsPerPage.value} de ${
			props.totalPages * itemsPerPage.value
		}`

		//exibi o footer da tabela
		const footer = document.getElementsByClassName("v-data-table-footer")
		footer[0].setAttribute("style", "margin: 2rem 0")

		//seta os tr com os ids das comissões em tela
		const tr = document.getElementsByTagName("tr")
		props.data.forEach((e, index) => {
			if (tr[index]) {
				tr[index + 1]?.setAttribute("id", `${e.id}`)
			}
		})
	}
}

const handlingTableHeader = () => {
	situation.value = store.getters.getSituation

	headers.value = []

	if (situation.value == Status.PAID) {
		const paymentDate = 4

		header.splice(paymentDate, 1, {
			title: "Data pagamento",
			key: "paymentDate",
			sortable: false,
			tooltip: "Essa coluna exibe a data de pagamento da nota fiscal ",
		})
	}

	if (situation.value == Status.PAID || situation.value == Status.SENT) {
		const custumerNote = 3

		header.splice(custumerNote, 0, {
			title: "N. Nota",
			key: "customerNote",
			sortable: false,
			tooltip: "Essa coluna exibe o número da nota enviada",
		})
	}

	headers.value = header
}

const handlingTableColors = () => {
	fitColor.value = props.data.map((d) => d.negativeValue)

	negativeNetCommission.value = props.data.map((d) => d.negativeNetCommission)

	negativeGroosCommission.value = props.data.map(
		(d) => d.negativeGroosCommission
	)

	totalPortion.value = props.data.map((d) => d.totalPortion)

	negativeTotalNetCommission.value = props.data.map(
		(d) => d.negativeTotalNetCommission
	)
}

onMounted(() => {
	handlingTheTable()

	handlingTableHeader()

	handlingTableColors()
})

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showCreateFitModal))
      ? (_openBlock(), _createBlock(CreateAdjustment, {
          key: 0,
          "create-fit": createFit,
          "validation-error": _unref(validationError),
          onCloseModal: _cache[0] || (_cache[0] = (value) => _isRef(showCreateFitModal) //@ts-ignore
 ? showCreateFitModal.value = value : showCreateFitModal = value)
        }, null, 8, ["validation-error"]))
      : _createCommentVNode("", true),
    (_unref(showFitDisplayModal))
      ? (_openBlock(), _createBlock(FitDisplayModal, {
          key: 1,
          adjustment: _unref(adjustment),
          onCloseModal: _cache[1] || (_cache[1] = (value) => _isRef(showFitDisplayModal) //@ts-ignore
 ? showFitDisplayModal.value = value : showFitDisplayModal = value)
        }, null, 8, ["adjustment"]))
      : _createCommentVNode("", true),
    (_unref(showItemsTable))
      ? (_openBlock(), _createBlock(ItemsTable, {
          key: 2,
          item: _unref(items),
          onCloseModal: _cache[2] || (_cache[2] = (value) => _isRef(showItemsTable) //@ts-ignore
 ? showItemsTable.value = value : showItemsTable = value)
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (__props.data.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require('@/assets/Logo-Prime.png'),
              alt: "Logo Prime",
              class: "ml-3"
            }, null, 8, _hoisted_3),
            _createVNode(_unref(H2), { class: "text-v_gray3" }, {
              default: _withCtx(() => [
                _createTextVNode("Pesquise suas comissões")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(VDataTableServer), {
        "show-select": 
				_unref(hasPermission)([_unref(Permission).RESALE]) && _unref(situation) == _unref(Status).AVAILABLE
			,
        "items-length": __props.totalPages * _unref(itemsPerPage),
        page: _unref(pages),
        headers: _unref(headers),
        items: __props.data,
        "page-text": _unref(pageText),
        "items-per-page-options": _unref(setItemsPerPage),
        "items-per-page": _unref(itemsPerPage),
        "onUpdate:itemsPerPage": [
          _cache[3] || (_cache[3] = ($event: any) => (_isRef(itemsPerPage) ? (itemsPerPage).value = $event : itemsPerPage = $event)),
          getPerPage
        ],
        "items-per-page-text": "Itens por página",
        modelValue: _unref(selected),
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => (_isRef(selected) ? (selected).value = $event : selected = $event)),
          getRowStyle
        ],
        "item-value": "id",
        class: "elevation-1",
        "onUpdate:page": onChangePage
      }, {
        headers: _withCtx(({ columns }) => [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: column.key,
                class: "v-data-table__th"
              }, [
                (
									index == 0 &&
									_unref(hasPermission)([_unref(Permission).RESALE]) &&
									_unref(situation) == _unref(Status).AVAILABLE
								)
                  ? (_openBlock(), _createBlock(_component_v_checkbox, {
                      key: 0,
                      class: "top-0 left-2 absolute",
                      onClick: select80FirstAvailableCommissions
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Seleciona as 80 primeiras comissões ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(column.title) + " ", 1),
                  (
										index > 0 &&
										_unref(hasPermission)([_unref(Permission).RESALE]) &&
										_unref(situation) == _unref(Status).AVAILABLE
									)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        activator: "parent",
                        location: "top"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(column.tooltip), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_unref(hasPermission)([_unref(Permission).RESALE]))
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 1,
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(column.tooltip), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        "item.status": _withCtx(({ item }) => [
          _createElementVNode("p", {
            style: {"color":"rgb(236, 46, 12)"},
            class: _normalizeClass(
						item.columns.status == 'cancelada'
							? 'text-v_red w-32 block'
							: 'hidden'
					)
          }, " Cancelada ", 2),
          _createElementVNode("p", {
            style: {"color":"rgb(236, 158, 12)"},
            class: _normalizeClass(
						item.columns.status == 'devolvida'
							? 'text-v_red w-32 block'
							: 'hidden'
					)
          }, " Devolvida ", 2),
          _createElementVNode("p", {
            class: _normalizeClass(
						item.columns.status == '' ? 'text-v_dark_blue w-32 block' : 'hidden'
					)
          }, [
            _createVNode(_component_v_icon, { icon: "mdi-dots-horizontal" })
          ], 2)
        ]),
        "item.discount": _withCtx(({ item }) => [
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.columns.discount), 1)
        ]),
        "item.netCommission": _withCtx(({ item, index }) => [
          _createElementVNode("p", {
            class: _normalizeClass(
						_unref(negativeNetCommission)[index]
							? 'text-v_red w-32'
							: 'text-v_green w-32'
					)
          }, _toDisplayString(item.columns.netCommission), 3)
        ]),
        "item.portion": _withCtx(({ item, index }) => [
          _createElementVNode("p", null, _toDisplayString(item.columns.portion) + "/" + _toDisplayString(_unref(totalPortion)[index]), 1)
        ]),
        "item.groosCommission": _withCtx(({ item, index }) => [
          _createElementVNode("p", {
            class: _normalizeClass(
						_unref(negativeGroosCommission)[index]
							? 'text-v_red w-32'
							: 'text-v_green w-32'
					)
          }, _toDisplayString(item.columns.groosCommission), 3)
        ]),
        "item.totalNetCommission": _withCtx(({ item, index }) => [
          _createElementVNode("p", {
            class: _normalizeClass(
						_unref(negativeTotalNetCommission)[index]
							? 'text-v_red w-32'
							: 'text-v_green w-32'
					)
          }, _toDisplayString(item.columns.totalNetCommission), 3)
        ]),
        "item.totalSales": _withCtx(({ item, index }) => [
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.columns.totalSales.toLocaleString("pt-BR", {
							style: "currency",
							currency: "BRL",
						})), 1)
        ]),
        "item.adjustment": _withCtx(({ item, index }) => [
          _createElementVNode("p", {
            class: _normalizeClass(
						_unref(fitColor)[index]
							? 'text-v_red  text-left'
							: 'text-v_green  text-left'
					)
          }, _toDisplayString(item.columns.adjustment), 3)
        ]),
        "item.data-table-expand": _withCtx(({ index, item }) => [
          _createVNode(_component_v_menu, { transition: "slide-y-transition" }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("button", _mergeProps(props, { class: "mx-5" }), [
                _createVNode(_component_v_icon, {
                  icon: "mdi-pencil-box-outline",
                  class: ""
                })
              ], 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_unref(hasPermission)([_unref(Permission).ADMIN]))
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (getCommissionAdjust(index))
                          }, "Ajustar", 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (takeAdjustments(index))
                      }, "Consultar Ajustes", 8, _hoisted_7)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_unref(takeItemsByCommission)(index))
                      }, " Consultar Itens ", 8, _hoisted_8)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["show-select", "items-length", "page", "headers", "items", "page-text", "items-per-page-options", "items-per-page", "modelValue"])
    ])
  ], 64))
}
}

})